import React from 'react';
import {
  CloudIcon,
  ChartBarSquareIcon,
  CpuChipIcon,
  PresentationChartBarIcon,
  UserGroupIcon,
  CircleStackIcon,
} from '@heroicons/react/24/outline';
import { ANALYTICS_COVERAGE, HOME_SERVICE_SECTIONS } from '../../../content/enterpriseMessaging';
import SectionSurface from '../shared/SectionSurface';

const SECTION_ICONS = [
  CloudIcon,
  ChartBarSquareIcon,
  PresentationChartBarIcon,
  CpuChipIcon,
  CircleStackIcon,
  UserGroupIcon,
];

/**
 * Analytics coverage: centered intro + six linked capability cards (font scale aligned).
 */
export default function ContentService() {
  const { eyebrow, title, intro } = ANALYTICS_COVERAGE;

  return (
    <SectionSurface variant="contour" decor="diagonal" bleed="both" flowTop flowBottom overlap className="section">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">{eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-600">{intro}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {HOME_SERVICE_SECTIONS.map((section, index) => {
            const Icon = SECTION_ICONS[index] || ChartBarSquareIcon;
            return (
              <a key={section.title} href={section.href} className="card-hover group p-6">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-brand-50 text-brand-600">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-5 text-base font-semibold text-ink-900">{section.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-ink-600">{section.description}</p>
                <span className="mt-5 inline-flex items-center text-sm font-medium text-brand-700 group-hover:text-brand-800">
                  Learn more <span className="ml-1" aria-hidden="true">→</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </SectionSurface>
  );
}
